import React from 'react'
import { Box } from '@mui/system'
import { makeStyles } from '@material-ui/core'

const DEFAULTS = ['#549FF5', '#1DBE1D', '#FDD71A', '#ED1C24']

const HMapColorPicker = ({ name = 'colorHexes', colors, onChange, disabled }) => {
    const palette = Array.isArray(colors) && colors.length === 4 ? colors : DEFAULTS
    const classes = useStyles()

    const handleColorChange = (idx) => (e) => {
        const next = [...palette]
        next[idx] = e.target.value
        onChange?.({ target: { name, value: next } })
    }

    return (
        <Box className={classes.root}>
            {['Low', 'Mid', 'High', 'Max'].map((label, i) => (
                <div key={label} className={classes.swatch}>
                    <label className={classes.label}>{label}</label>
                    <input
                        type="color"
                        value={palette[i]}
                        onChange={handleColorChange(i)}
                        disabled={!!disabled}
                        className={classes.input}
                        aria-label={`${label} color`}
                    />
                    <span className={classes.hex}>{palette[i]}</span>
                </div>
            ))}
        </Box>
    )
}

export default React.memo(HMapColorPicker)

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        display: 'grid',
        gap: 12,
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        alignItems: 'center',
        padding: '6px 0 12px'
    },
    swatch: {
        display: 'grid',
        gridTemplateRows: 'auto auto auto',
        justifyItems: 'center'
    },
    label: {
        ...theme.typography.p,
        color: theme.palette.tertiary?.accent || theme.palette.text.secondary,
        marginBottom: 4
    },
    input: {
        width: 36,
        height: 36,
        padding: 0,
        border: 'none',
        background: 'transparent',
        cursor: 'pointer'
    },
    hex: {
        fontSize: 11,
        color: theme.palette.text.secondary,
        marginTop: 4
    }
}))